<template>
	<v-card rounded="xl">
		<v-card-title>
			<div class="d-flex justify-space-between ma-2">
				<div>{{ $t('account') }}</div>
				<v-icon @click="$emit('close')">mdi-close</v-icon>
			</div>
		</v-card-title>
		<v-card-item>
			<v-row>
				<v-col cols="6">
					<div>
						<div>{{ $t('email') }}<span class="text-red">*</span></div>
						<v-text-field variant="outlined" rounded="lg" placeholder="Email@example.com"
							v-model="formValues.email" />
					</div>
					<div>
						<div>
							{{ $t('first_name') }}
							<span class="text-red">*</span>
						</div>
						<v-text-field variant="outlined" rounded="lg" placeholder="First Name"
							v-model="formValues.firstName" />
					</div>
					<div>
						<div>
							{{ $t('phone') }}
							<span class="text-red">*</span>
						</div>
						<v-text-field variant="outlined" rounded="lg" placeholder="Phone Number"
							v-model="formValues.phone" />
					</div>
					<div class="d-flex">
						<div class="my-2 mr-5">
							{{ $t('role') }} <span class="text-red">*</span>
						</div>

						<div style="width: 150px">
							<v-select v-model="formValues.roleId" :items="formValues.roleList" placeholder="Select Role"
								variant="outlined" rounded="xl" hide-details density="compact" ref="roleSelect">
								<template #item="{ item }">
									<v-list-item @click="selectRole(item)" :active="formValues.roleId === item.value
										" :class="item.raw.color">
										{{ item.title }}
									</v-list-item>
								</template>

								<template #selection="{ item }">
									<div :class="item.raw.color">
										{{ item.title }}
									</div>
								</template>
							</v-select>
						</div>
					</div>
				</v-col>
				<v-col cols="6">
					<div>
						<div>{{ $t('password') }} <span class="text-red">*</span></div>

						<v-text-field variant="outlined" rounded="lg" type="password"
							:placeholder="$t('change_password')" :readonly="isChangePasswordVisible" v-model="password">
							<template #append-inner v-if="isChangePasswordVisible">
								<v-btn flat class="text-capitalize text-caption text-blue"
									style="text-decoration: underline" @click="isChangePasswordDialogOpen = true">
									{{ $t('change_password') }}
								</v-btn>
							</template>
						</v-text-field>
					</div>
					<div>
						<div>
							{{ $t('last_name') }}
							<span class="text-red">*</span>
						</div>
						<v-text-field variant="outlined" rounded="lg" placeholder="Last Name"
							v-model="formValues.lastName" />
					</div>
					<div>
						<div>
							{{ $t('department') }}
							<span class="text-grey">(Optional)</span>
						</div>
						<v-text-field variant="outlined" rounded="lg" placeholder="Department"
							v-model="formValues.specialization" />
					</div>
					<div class="d-flex">
						<div class="my-2 mr-5">
							{{ $t('status') }} <span class="text-red">*</span>
						</div>

						<div style="width: 160px">
							<v-select v-model="formValues.active" :items="formValues.statusList"
								placeholder="Select Status" variant="outlined" rounded="xl" hide-details
								density="compact" ref="statusSelect">
								<template #item="{ item }">
									<v-list-item @click="selectStatus(item)" :active="formValues.active === item.value
										" :class="item.raw.color">
										{{ item.title }}
									</v-list-item>
								</template>
								<template #selection="{ item }">
									<div :class="item.raw.color">
										{{ item.title }}
									</div>
								</template>
							</v-select>
						</div>
					</div>
				</v-col>
			</v-row>
			<v-card-footer>
				<v-row>
					<v-col cols="6">
						<div class="my-5">
							<v-btn style="border: 1px solid #ff7e87" v-if="isDeleteAccountVisible" rounded="xl"
								@click="isDeleteDialogOpen = true">{{ $t('delete_account') }}</v-btn>
						</div>
					</v-col>
					<v-col cols="6">
						<div class="my-5 d-flex flex-row-reverse">
							<v-btn variant="text" rounded="xl" class="text-black bg-red-lighten-4"
								v-if="personalDetail.id == null" @click="saveForm">
								{{ $t('save_change') }}
							</v-btn>
							<v-btn variant="text" rounded="xl" class="text-black bg-red-lighten-4" v-else
								@click="saveEditForm">
								{{ $t('save_change') }}
							</v-btn>

							<v-btn variant="plain" @click="$emit('close')">
								{{ $t('close') }}
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-card-footer>
		</v-card-item>
	</v-card>
	<v-dialog v-model="isDeleteDialogOpen" width="600">
		<v-card style="border-radius: 15px">
			<v-card-text>
				<div class="text-h5 font-weight-bold my-2">
					Delete Account ?
				</div>
				<div>
					Would you like to Delete this account ?
					<span style="color: #ff7e87">user will be permanently deleted from user list</span>
				</div>
			</v-card-text>
			<v-card-footer>
				<div class="d-flex ma-3 flex-row-reverse">
					<div>
						<v-btn variant="text" rounded="xl" class="text-black bg-red-lighten-4"
							@click="deleteAccount(personalDetail.id)">Delete</v-btn>
					</div>
					<div>
						<v-btn variant="text" class="mr-2" @click="isDeleteDialogOpen = false">{{ $t('cancel')
						}}</v-btn>
					</div>
				</div>
			</v-card-footer>
		</v-card>
	</v-dialog>
	<v-dialog v-model="isChangePasswordDialogOpen" width="600">
		<v-card style="border-radius: 15px">
			<v-card-text>
				<div class="mx-3">
					<div class="d-flex justify-space-between">
						<div class="text-h6">{{ $t('change_password') }}</div>
						<div>
							<v-icon class="font-weight-bold"
								@click="isChangePasswordDialogOpen = false">mdi-close</v-icon>
						</div>
					</div>
					<div class="my-2 text-subtitle-1">
						{{ $t('new_password') }} <span style="color: #ff7e87">*</span>
					</div>
					<div>
						<v-text-field variant="outlined" rounded="lg" :placeholder="$t('new_password')" type="password"
							v-model="newPassword" />
					</div>

					<div class="d-flex flex-row-reverse">
						<div>
							<v-btn variant="text" rounded="xl" class="text-black bg-red-lighten-4"
								:disabled="!newPassword" @click="savePassword">
								{{ $t('save_change') }}
							</v-btn>
						</div>

						<div class="mr-3">
							<v-btn variant="text" @click="isChangePasswordDialogOpen = false">
								{{ $t('cancel') }}
							</v-btn>
						</div>
					</div>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
const defaultFormValues = {
	statusList: [
		{ title: 'ACTIVE', color: 'text-green-lighten-2', value: true },
		{ title: 'INACTIVE', color: 'text-red-lighten-2', value: false },
	],
	roleList: [
		{ title: 'OWNER', color: 'text-green-lighten-2', value: 'owner' },
		{ title: 'ADMIN', color: 'text-red-lighten-2', value: 'administrator' },
	],
	email: '',
	firstName: '',
	lastName: '',
	phone: '',
	password: '',
	specialization: '',

	active: null,
	roleId: null,
}

export default {
	props: {
		personalDetail: {
			type: Object,
			default: () => ({}),
		},
		isChangePasswordVisible: {
			type: Boolean,
		},
		isDeleteAccountVisible: {
			type: Boolean,
		},
	},
	data() {
		return {
			formValues: {},
			isDeleteDialogOpen: false,
			isChangePasswordDialogOpen: false,
			password: '',
			newPassword: '',
		}
	},
	created() {
		this.setFormValues()
	},
	emits: ['deleteAccount', 'saveForm', 'saveEditForm'],
	methods: {
		setFormValues() {
			this.formValues = {
				...defaultFormValues,
				...this.personalDetail,
			}
		},
		savePassword() {
			// Add your save password logic here
			this.password = this.newPassword
			this.isChangePasswordDialogOpen = false
		},
		deleteAccount(id) {
			this.isDeleteDialogOpen = false
			this.$emit('deleteAccount', id)

		},
		changePassword() {
			//
		},
		selectRole(item) {
			this.formValues.roleId = item.value
			this.$refs.roleSelect.blur()
		},
		selectStatus(item) {
			this.formValues.active = item.value
			this.$refs.statusSelect.blur()
		},
		saveForm() {
			this.formValues.password = this.password
			this.$emit('saveForm', this.formValues)
		},
		saveEditForm() {
			this.formValues.password = this.password
			this.$emit('saveEditForm', this.formValues)
		},
	},
}
</script>
